module.exports = __webpack_public_path__ + "img/contactBg.2f53b802.png";